"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.appSuiteInitialState = void 0;

/**
 * The initial state of the appSuite area.
 */
var appSuiteInitialState = {
  enabledApps: {
    value: {},
    isLoading: true
  }
};
exports.appSuiteInitialState = appSuiteInitialState;